import styled, { keyframes, css } from "styled-components";

const appearBottom = keyframes`
from {
  opacity: 0;
  bottom: -40px;
}
to {
  opacity: 1;
  bottom: 0;
}`;
export const ModalWrapper = styled.div<any>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;

  ${({ open }) =>
    open &&
    css`
      transition: 0.2s;
      visibility: visible;
      opacity: 1;
    `}
  @media screen and (max-width: 740px) {
    z-index: 190;
  }
`;

export const AuthContent = styled.div`
  width: 520px;
  background: #fff;
  border-radius: 16px;
  position: relative;
  text-align: center;

  form > .error {
    text-align: left;
    display: block;
    width: 100%;
    margin: 0 0 12px;
    display: flex;
    align-items: flex-start;
    svg {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
    span {
      color: #000;
      font-size: 14px;
      padding-top: 1px;
    }
  }

  form > span {
    text-align: left;
    display: block;
    width: 100%;
    margin: -4px 0 8px;
    padding-left: 16px;
  }

  .auth-content {
    position: relative;
    padding: 32px 40px 36px;
    @media screen and (min-width: 741px) {
      overflow-x: hidden;
      overflow-y: overlay;
      max-height: 90vh;
      ::-webkit-scrollbar {
        width: 8px;
      }
      ::-webkit-scrollbar-track {
        background: transparent;
      }
      ::-webkit-scrollbar-thumb {
        background: #c4c4c480;
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }

    &.-recover {
      animation: ${appearBottom} 0.5s ease-out;
    }
  }
  // for update password
  .back,
  .back svg {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    svg {
      margin-right: 16px;
    }
  }
  .close {
    position: absolute;
    z-index: 10;
    top: -44px;
    right: -0px;
    background-color: #f5f6f6;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    span {
      display: none;
    }
  }
  .icon,
  .brand-logo {
    display: none;
  }
  .heading {
    font-size: 24px;
    margin-bottom: 32px;
    font-weight: 700;
    .mobile {
      display: none;
    }
  }
  .switch-auth {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    font-size: 14px;
    line-height: 1.8;

    button {
      font-size: 14px;
      line-height: 48px;
      color: #000;
      width: calc(50% - 8px);
      position: relative;
      padding: 0 12px;

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        border-radius: 4px;
        background: #c4c4c4;
      }
      &.active {
        font-weight: bold;

        &:after {
          background: #000;
        }
      }
    }
  }

  .update-password {
    display: flex;
    margin-bottom: 16px;
    font-size: 12px;
    font-weight: bold;
    color: var(--primary-hyperlink);
  }

  .divider {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin: 16px 0;
    ::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    }
    span {
      position: relative;
      z-index: 1;
      background-color: white;
      width: 40px;
      color: rgba(0, 0, 0, 0.5);
      font-size: 13px;
    }
  }

  .alt-auth {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc(50% - 8px);
      height: 48px;
      border: 1px solid #dcdde0;
      transition: 0.5s;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 500;
      :hover {
        border: 1.5px solid var(--primary);
      }
      svg {
        margin-right: 14px;
      }
    }
  }
  // __
  .passwords {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 8px;
    > * {
      width: calc(50% - 8px);
    }
  }
  .terms {
    text-align: center;
    margin-bottom: 20px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.7;
    a {
      font-weight: bold;
      font-size: 12px;
      margin: 0 4px;
      transition: 0.4s;
      text-decoration: underline;
      :not(:last-of-type) {
        margin-right: 4px;
      }
    }
  }

  @media screen and (max-width: 1450px) {
    width: 460px;
    overflow: hidden;
    form > .error {
      svg {
        margin-right: 8px;
      }
      span {
        font-size: 12px;
      }
    }
    .auth-content {
      padding: 24px 28px;
    }
    .heading {
      font-size: 22px;
      margin-bottom: 12px;
    }
    .switch-auth button {
      line-height: 40px;
    }
    .close {
      top: 16px;
      right: 16px;
    }
  }
  @media screen and (max-width: 740px) {
    width: 100%;
    max-width: 100%;
    min-height: 100%;
    max-height: 100%;
    overflow-y: auto;
    padding: 12px 16px 160px;
    border-radius: 0;
    .heading {
      font-size: 16px;
      margin-bottom: 12px;
      span {
        display: none;
      }
      .mobile {
        display: inline;
      }
    }
    .auth-content {
      padding: 0;
    }
    .close {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5;
      border-radius: 0 0 50% 0;
      background-color: #fff;
      text-align: center;
      width: 44px;
      height: 44px;
      > svg {
        display: none;
      }
      span {
        display: flex;
        width: 100%;
        height: 100%;
      }
    }
    .back {
      display: none;
    }
    .brand-logo {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      background-color: var(--primary);
      color: #000;
      border-radius: 8px;
      margin: 12px auto 16px;
      svg {
        height: 20px;
      }
    }
    .switch-auth {
      margin-bottom: 20px;
      button {
        color: var(--primary);
        width: 50%;
        color: #000;
        font-size: 11px;
        ::after {
          height: 0.5px;
        }
        &.active::after {
          background-color: var(--primary);
          height: 1px;
        }
      }
    }
    .update-password {
      font-size: 12px;
    }
    .divider {
      margin: 8px 0 18px;
      span {
        font-size: 12px;
      }
    }
    .alt-auth {
      button {
        border: 1px solid #dcdde0;
        width: 100%;
        font-size: 12px;
        font-weight: 500;
        :first-of-type {
          margin-bottom: 10px;
        }
      }
    }
    .passwords {
      > div,
      > span {
        width: 100%;
      }
    }
    &.registe-mobile {
      display: flex;
      flex-direction: column;
      .divider {
        order: 4;
      }
      .alt-auth {
        order: 5;
      }
      .terms {
        font-size: 11px;
        text-align: left;
        a {
          font-size: 11px;
        }
      }
    }
  }
`;
export const AuthPrimaryBtn = styled.button`
  line-height: 48px;
  width: 100%;
  border-radius: 10px;
  background: #000;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  transition: 0.4s;
  :hover {
    /* background: #2f2f2f; */
  }
  &.-disabled {
    opacity: 0.5;
  }
  @media screen and (max-width: 740px) {
    font-size: 12px;
  }
`;

export const NotificationBoxWrapper = styled.div`
  width: 100%;
  height: fit-content;
  padding: 16px;
  border: 1px solid transparent;
  border-radius: 8px;
  margin: 16px 0;
  display: none;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #ea5651;
  > svg {
    margin-right: 16px;
  }
  &.-error {
    display: flex;
    background: #faedea;
    color: #000;
    border: 1px solid #f4b1ad;
    border-radius: 8px;
    align-items: center !important;
    flex-direction: row !important;
    padding: 16px 20px !important;
    justify-content: center !important;
    @media screen and (max-width: 740px) {
      justify-content: flex-start !important;

      svg {
        margin-right: 10px;
      }
    }
  }

  ul {
    text-align: left;
    list-style-type: disc;
    margin: 0 0 0 24px;

    li {
      list-style: unset;
    }
  }

  &.flex-column {
    flex-direction: column;
    align-items: flex-start;
  }
`;

// info msg portal
export const ContainerPopupWrapper = styled.div<any>`
  position: fixed;
  z-index: 1100;
  bottom: 60px;
  width: 100%;
  pointer-events: none;

  @media screen and (max-width: 1400px) {
    bottom: 60px;
  }
  @media screen and (max-width: 960px) {
    bottom: 72px;
  }
  @media screen and (max-width: 740px) {
    bottom: 60px;
    > div {
      padding: 0;
    }
    z-index: 190; // under fixed mobile nav - 200
  }
  ${({ upper }) =>
    upper &&
    css`
      pointer-events: unset;
      z-index: 9999999999 !important;
      @media screen and (max-width: 740px) {
        z-index: 190 !important;
      }
    `}
`;
// Auth Information Popup
export const AuthInformation = styled.div`
  max-width: 288px;
  min-height: 36px;
  margin-left: auto;
  background: var(--primary-light);
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  transition: 0.75s;

  &.-error {
    background: #cc3300;
    color: #fff;
    margin: 8px 0 0 0;
    opacity: 1;
    transition: 0.75s;
  }

  &.-success {
    color: #000;
    background: var(--primary-light);
    margin: 8px 0 0 0;
    opacity: 1;
    transition: 0.75s;
  }

  &.-hide {
    opacity: 0;
    transition: 0.75s;
  }

  @media screen and (max-width: 1300px) {
    padding: 12px;
  }
  @media screen and (max-width: 740px) {
    max-width: 100%;
    font-size: 10px;
    justify-content: left;
    padding: 12px 16px;
    border-radius: 0;
  }
`;

// Update Password
export const UpdateWrapper = styled.div`
  margin-top: 36px;
  text-align: center;
  .headline {
    font-size: 22px;
    margin-bottom: 22px;
    font-weight: 700;
  }
  .description {
    font-size: 14px;
    max-width: 400px;
    margin: 0 auto 30px;
  }
  form {
    max-width: 312px;
    margin: 0 auto;

    button {
      width: 100%;
    }
    .primary {
      line-height: 1.5rem;
      color: rgb(0, 0, 0);
      background-color: var(--primary);
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 10px;
      height: 48px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 700;
      font-family: inherit;
    }
    input::-webkit-validation-bubble-message,
    select::-webkit-validation-bubble-message,
    textarea::-webkit-validation-bubble-message {
      display: none;
    }
  }
  sup {
    display: block;
    color: red;
    text-align: left;
    padding-left: 20px;
    margin: -8px 0 12px;
  }
  .login {
    margin-top: 24px;
    font-size: 14px;
    button {
      width: auto;
      margin-left: 4px;
      font-size: 14px;
      font-weight: bold;
      color: var(--primary);
    }
  }

  .step-two-form {
    margin-top: 20px;
    p {
      font-size: 12px;
      margin: 0 -10px 16px;
      span {
        font-weight: 700;
      }
    }
    .code-input {
      margin-bottom: 16px;
      input {
        border-radius: 10px;
        border: 1px solid #e0e2e8;
        line-height: 48px;
        padding: 0 12px;
      }
    }
  }
  @media screen and (max-width: 740px) {
    sup {
      padding-left: 12px;
    }
  }
`;

// success update
export const SuccessWrapper = styled.div`
  margin: 20px auto;
  max-width: 288px;
  .hero {
    position: relative;
    width: 180px;
    height: 132px;
    margin: 0 auto 24px;
  }
  h2 {
    font-size: 18px;
    margin: 0 auto 16px;
    max-width: 240px;
  }
  .description {
    font-size: 12px;
    margin-bottom: 28px;
    padding: 0 12px;
  }
  button {
    width: 100%;
  }
  .send-again {
    margin: 24px 0 12px;
    font-size: 14px;
    font-weight: 500;
    button {
      width: auto;
      color: var(--primary-hyperlink);
      margin-left: 4px;
      font-size: 14px;
      font-weight: bold;
    }
  }
`;
